/*
* About Us Page
* */

let AboutUs = {
    init() {
        const app = new Vue({
            el: "#about-us-app",
            data: {
                // Search locations
                search: '',
                bankData: window.bankData,
                pageNumber: 0,

                // Contact form validation
                errors: '',

                // User location
                userLocation: {
                    lat: 0,
                    long: 0
                },

                coord: {
                    lat: 0,
                    long: 0
                },
            },

            props: {
                size: {
                    type: Number,
                    required: false,
                    default: 6
                },
            },
            methods: {
                getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
                    const $this = this;
                    var R = 6371; // Radius of the earth in km
                    var dLat = deg2rad(lat2-lat1);  // deg2rad below
                    var dLon = deg2rad(lon2-lon1);
                    var a =
                        Math.sin(dLat/2) * Math.sin(dLat/2) +
                        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                        Math.sin(dLon/2) * Math.sin(dLon/2)
                    ;
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                    var d = R * c; // Distance in km
                    return (d / 1.609).toFixed(2);

                    function deg2rad(deg) {
                        return deg * (Math.PI/180)
                    }
                },
                nextPage() {
                    this.pageNumber++;
                },
                prevPage() {
                    this.pageNumber--;
                },
                pageFind: function(index) {
                    this.pageNumber = index;
                },
                contactSubmit: function(e) {
                    e.preventDefault();

                    $.ajax({
                        url: '/contact',
                        type: 'post',
                        data: {
                            first_name: $('input[name=first_name]').val(),
                            last_name: $('input[name=last_name]').val(),
                            address: $('input[name=address]').val(),
                            city: $('input[name=city]').val(),
                            state: $('input[name=state]').val(),
                            postal_code: $('input[name=postal_code]').val(),
                            phone: $('input[name=phone]').val(),
                            email: $('input[name=email]').val(),
                            topic: $('#topic option:selected').val(),
                            new_customer: $('input[name=new_customer]:checked').val(),
                            business_name: $('input[name=business_name]').val(),
                            alt_phone: $('input[name=alt_phone]').val(),
                            time_to_contact: $('#time_to_contact option:selected').val(),
                            details: $('#details-input').val(),
                            recipient: $('#topic option:selected').attr('topic-email')
                        },
                        success: function(data) {
                            console.log(data);
                            var errors = document.getElementById("errors");
                            if(data.errors) {
                                if(data.errors.indexOf('first_name') >= 0) {
                                    $('input[name=first_name]').css('border-color', 'red');
                                    $('.first-name-error').remove();
                                    $('<span class="first-name-error">First Name is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=first_name]').css('border-color', 'black');
                                    $('.first-name-error').remove();
                                }

                                if(data.errors.indexOf('last_name') >= 0) {
                                    $('input[name=last_name]').css('border-color', 'red');
                                    $('.last-name-error').remove();
                                    $('<span class="last-name-error">Last Name is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=last_name]').css('border-color', 'black');
                                    $('.last-name-error').remove();
                                }

                                if(data.errors.indexOf('address') >= 0) {
                                    $('input[name=address]').css('border-color', 'red');
                                    $('.state-error').remove();
                                    $('<span class="state-error">Last Name is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=address]').css('border-color', 'black');
                                    $('.state-error').remove();
                                }

                                if(data.errors.indexOf('city') >= 0) {
                                    $('input[name=city]').css('border-color', 'red');
                                    $('.city-error').remove();
                                    $('<span class="city-error">City is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=city]').css('border-color', 'black');
                                    $('.city-error').remove();
                                }

                                if(data.errors.indexOf('state') >= 0) {
                                    $('input[name=state]').css('border-color', 'red');
                                    $('.state-error').remove();
                                    $('<span class="state-error">State is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=state]').css('border-color', 'black');
                                    $('.state-error').remove();
                                }

                                if(data.errors.indexOf('postal_code') >= 0) {
                                    $('input[name=postal_code]').css('border-color', 'red');
                                    $('.postal-error').remove();
                                    $('<span class="postal-error">Zip Code is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=postal_code]').css('border-color', 'black');
                                    $('.postal-error').remove();
                                }

                                if(data.errors.indexOf('email') >= 0) {
                                    $('input[name=email]').css('border-color', 'red');
                                    $('.email-error').remove();
                                    $('<span class="email-error">Email is a required field.</span>').appendTo(errors);
                                } else if(data.errors.indexOf('email_format') >= 0) {
                                    $('input[name=email]').css('border-color', 'red');
                                    $('.email-error').remove();
                                    $('<span class="email-error">Email format is invalid.</span>').appendTo(errors);
                                } else {
                                    $('input[name=email]').css('border-color', 'black');
                                    $('.email-error').remove();
                                }

                                if(data.errors.indexOf('phone') >= 0) {
                                    $('input[name=phone]').css('border-color', 'red');
                                    $('.phone-error').remove();
                                    $('<span class="phone-error">Phone Number is a required field.</span>').appendTo(errors);
                                } else {
                                    $('input[name=phone]').css('border-color', 'black');
                                    $('.phone-error').remove();
                                }
                            } else {
                                $('form').css({'display': 'none'});
                                $('.content-hidden').fadeIn(1000).css({'display': 'flex'});
                            }

                        }
                    });

                },

                async googleMapp() {
                    this.coord = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.search}&key=AIzaSyB_Rj66e_9bRMEPKXdqyqObtUrW0m_QoDA`)
                        .then((response) => response.json())
                        .then((data) => data.results[0]);

                    return true;
                },

                byClosest(a, b) {
                    if (a.distance < b.distance)
                        return -1;
                    if (a.distance > b.distance)
                        return 1;
                    return 0;
                }

            },

            computed: {

                searchBanks() {

                    const start = this.pageNumber * this.size,
                        end = start + this.size;


                    function byClosest(a, b) {
                        if (Number(a.distance) < Number(b.distance))
                            return -1;
                        if (Number(a.distance) > Number(b.distance))
                            return 1;
                        return 0;
                    }

                    if (this.search === '') {
                        return this.bankData.filter(bank => {
                            if (this.userLocation.lat !== 0 && this.userLocation.long !== 0) {
                                return bank.distance = this.getDistanceFromLatLonInKm(this.userLocation.lat, this.userLocation.long, bank.lat, bank.long);
                            }
                            return bank;
                        }).sort(byClosest).slice(start, end);
                    }

                    if(this.pageNumber > 0){
                        this.search = '';
                    }

                    this.pageNumber = 0;

                    // Returns data on search
                    var filBank = this.bankData.filter(bank => {

                        if(bank){
                            bank.distance = 0;
                            return bank.name.toLowerCase().includes(this.search.toLowerCase()) ||
                                bank.address.toLowerCase().includes(this.search.toLowerCase()) ||
                                bank.postal_code.includes(this.search) ||
                                bank.city.toLowerCase().includes(this.search.toLowerCase()) ||
                                bank.state.toLowerCase().includes(this.search.toLowerCase());

                        } else {

                        }
                    }).slice(start, end);

                    if(filBank.length){
                        return filBank;
                    }else {

                        var wsw = this.googleMapp();

                        var lat = this.coord.geometry.location.lat;
                        var lng = this.coord.geometry.location.lng;

                        return this.bankData.filter(bank => {
                            if (lat !== 0 && lng !== 0) {

                                bank.distance = this.getDistanceFromLatLonInKm(lat, lng, bank.lat, bank.long);
                                // console.log(this.search,lat, lng, bank, bank.distance, this.coord);
                                return bank;
                            }
                            return bank;
                        }).sort(byClosest).slice(start, end);
                    }

                },

                pageCount() {
                    let l = this.bankData.length,
                        s = this.size;
                    return Math.ceil(l/s);
                }
            },
            mounted() {
                console.log("About Us Mounted");

                // Get user location
                if(navigator.geolocation) {
                    const $this = this;
                    navigator.geolocation.getCurrentPosition(function(position){
                        $this.userLocation.lat = position.coords.latitude;
                        $this.userLocation.long = position.coords.longitude;
                    });
                }
            },
        });
    }

}

export default AboutUs;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/AboutUs.js